import { endPoints, requestType } from "../theme/Variables";
import Api from "./index";

export const fetchAllUsers = () => {
  return Api(endPoints.allUser, null, requestType.GET);
};
export const updateUserStatus = (id, params) => {
  return Api(`${endPoints.updateUser}/${id}`, params, requestType.POST);
};
